module.exports = __webpack_public_path__ + "img/template3.2cf857fd.png";